module.exports = __webpack_public_path__ + "img/40_38_032_110.e6f26c00.jpg";